import React from 'react';
import InputMask from 'react-input-mask';
import TextField from "@material-ui/core/TextField";


const InputComponent = ({disabled, onChange, value, mask, ...rest}) => (
    <InputMask mask={mask} disabled={disabled} value={value} onChange={onChange}>
        {(inputProps) => (
            <TextField {...inputProps} {...rest} disabled={disabled}/>
        )}
    </InputMask>
)

export default InputComponent;